import { createRouter, createWebHistory } from 'vue-router'
import CardList from '@/views/CardList.vue'
import CardBuy from '@/views/CardBuy.vue'
import CardSell from '@/views/CardSell.vue'
import LoginView from '@/mini/views/LoginView.vue'
import Callback from '@/views/Callback.vue'
import { useAuthStore } from '@/mini/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { guestOnly: true },
      props: { redirectRouteName: 'home' },
    },
    {
      path: '/',
      name: 'home',
      component: CardList,
      meta: { requiresAuth: true },
    },
    {
      path: '/buy/:expansionCode?',
      name: 'buy',
      component: CardBuy,
      meta: { requiresAuth: true },
    },
    {
      path: '/sell',
      name: 'sell',
      component: CardSell,
      meta: { requiresAuth: true },
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth) {
    if (!authStore.isAuthenticated) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }

    const valid = await authStore.ensureValidToken()
    if (!valid) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }
  }

  if (to.meta.guestOnly && authStore.isAuthenticated) {
    const valid = await authStore.ensureValidToken()
    if (valid) return { name: 'home' }
  }

  return true
})

export default router
